import { useMutation } from '@apollo/client'
import { DeleteUser, DeleteUserVariables } from '../../types'
import { DELETE_USER } from './operations'

export const useDeleteUser = () => useMutation<DeleteUser, DeleteUserVariables>(DELETE_USER)
